/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsfeesaved2Inputs */

const en_ticketsfeesaved2 = /** @type {(inputs: Ticketsfeesaved2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saved`)
};

const de_ticketsfeesaved2 = /** @type {(inputs: Ticketsfeesaved2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gespeichert`)
};

/**
* | output |
* | --- |
* | "Saved" |
*
* @param {Ticketsfeesaved2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsfeesaved2 = /** @type {((inputs?: Ticketsfeesaved2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsfeesaved2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsfeesaved2(inputs)
	return de_ticketsfeesaved2(inputs)
});
export { ticketsfeesaved2 as "ticketsFeeSaved" }